export function extractOrganizationId(url: string): number | undefined {
  const match = url.match(/organization(?:s)?\/(\d+)/i);
  return match ? parseInt(match[1], 10) : undefined;
}
